import { BookOutlined } from '@ant-design/icons';
import { List, Input } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import folderimg from './../../../assets/folder.png'
import playicon from './../../../assets/play.png'

const { Search } = Input;

function Music(props) {
    let [music, setMusic] = useState(null)
    let [allAudios, setAllAudios] = useState([]) // Serverdan kelgan barcha audiolar
    let [filteredAudios, setFilteredAudios] = useState([]) // Filtrlangan audiolar
    let [searchText, setSearchText] = useState('')
    let [cats, setCats] = useState([])

    useEffect(() => {
        axios.get('audio').then((res) => {
            if (res.status === 200) {
                setAllAudios(res.data)
                setFilteredAudios(res.data) // Dastlab barcha audiolarni ko'rsatamiz
            }
        }).catch((err) => {
            console.log(err)
        })
        axios.get('/audio-categories').then((res) => {
            if (res.status === 200) {
                setCats(res.data)
            }
        }).catch((err) => {
            console.log(err)
        }
        )
    }, [])

    const handleSearch = (value) => {
        setSearchText(value)
        if (!value.trim()) {
            // Agar qidiruv maydoni bo'sh bo'lsa, barcha audiolarni ko'rsatamiz
            setFilteredAudios(allAudios)
        } else {
            // Qidiruv matni bo'yicha filtrlash
            const filtered = allAudios.filter(audio =>
                audio.name.toLowerCase().includes(value.toLowerCase())
            )
            setFilteredAudios(filtered)
        }
    }

    return (
        <div>
            <Row>
                <Col md={12}>
                    <h1><BookOutlined /> Audio Fayllar</h1>
                </Col>
                <Col md={3}>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '10px',
                            height: '68vh',
                            overflow: 'auto'
                        }}
                       
                    >
                         {
                            cats.map((item) => {
                                return (
                                    <div key={item.id} style={{ 
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#fff',
                                        padding: '10px',
                                        borderRadius: '5px'
                                    }} onClick={() => {
                                        setFilteredAudios(allAudios.filter((audio) => audio.cat_id === item.id))
                                    }}>
                                        <img width={100} src={folderimg} alt={item.name} />
                                        <p style={{textAlign: 'center', fontSize: '12px'}}>{item.name}</p>
                                    </div>
                                )
                            })
                         }
                    </div>
                </Col>
                <Col md={9}>
                    <Search
                        placeholder="Audio kitob nomini kiriting"
                        onChange={(e) => handleSearch(e.target.value)}
                        value={searchText}
                        style={{ marginBottom: 16 }}
                    />




                    <List
                        itemLayout="horizontal"
                        style={{
                            height: '55vh', overflow: 'auto',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            backgroundColor: '#fff'

                        }}
                        dataSource={filteredAudios}
                        header={<h5>Audio Kitoblar</h5>}
                        renderItem={(item, index) => (
                            <List.Item
                                onClick={() => setMusic(item.url)}
                                style={{ cursor: 'pointer' }}
                            >
                                <List.Item.Meta
                                    avatar={<img width={30} src={playicon} alt={item.name} />}
                                    title={item.name}
                                    description={item.author}
                                />
                            </List.Item>
                        )}
                    />

                    <AudioPlayer
                        src={music}
                        style={{ marginTop: 20 }}
                    />
                </Col>
            </Row>

        </div>
    );
}

export default Music;